const bgClass = 'card_type_bg';
const bgSelector = `.${bgClass}`;

function setType(module, cardType) {
  // cardType should be lowercase; eg 'visa', 'mastercard', 'amex', 'discover'
  // if cardType is null, this will apply generic classes

  const icon = $('[data-credit-card-type-target]');

  icon.removeClass();
  icon.addClass('payment_method_icon');
  icon.addClass('payment-method');

  module.removeClass();
  module.addClass('card_type_bg');
  module.addClass('card-type');

  if (cardType) {
    icon.addClass(cardType);
    module.addClass(cardType);
  } else {
    icon.addClass('generic');
    module.addClass('generic-cc');
  }
}

function init() {
  $('[data-credit-card-number]').each(function bindFields() {
    const $numberInput = $(this);
    let $cardbg;

    $(this).validateCreditCard((result) => {
      $numberInput.trigger('reverb.credit_card.validate_result', result);
      $cardbg = $numberInput.parents(bgSelector);

      if (result.card_type) {
        setType($cardbg, result.card_type.name);
      } else {
        setType($cardbg, null);
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', init);

module.exports = {
  init,
  setType,
};



// WEBPACK FOOTER //
// ./javascripts/components/credit_cards/card_type.js